// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/PermanentMarker-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Kodchasan/Kodchasan-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Kodchasan/Kodchasan-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/images/deadpool-wolverine-banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/images/icon-upload.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/images/upload.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    --primary-theme-color: #555;
    --primary-theme-color-hover: #555;
    --error-theme-color: #d03a40;
    --success-theme-color: #2eae5b;
    --progress-theme-color: #318ac6;
    --img-frame-max-width: 250px;
    --result-img-frame-max-width: 280px;
    --src-img-frame-max-width: 160px;
}

.page-container {
    height: 100% !important;
}

html,
body {
    height: 100%;
    margin: 0;
    background-color: #f2f4f5;
}

hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    width: 75%;
}

.gallery-hr {
    display: none;
}

@font-face {
    font-family: "PermanentMarker";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: bold;
}

@font-face {
    font-family: "Kodchasan-Light";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
    font-family: "Kodchasan-Bold";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
    font-family: "Kodchasan-Light";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.main-container {
    width: 70% !important;
    padding: 100px 0;
}

.img-transformation-container {
    display: none;
    background-size: cover;
}

.portfolio-container {
    text-align: center;
    padding: 50px;
    width: auto !important;
}

::-webkit-scrollbar {
    display: none;
}

@media (max-width: 1038px) {


    .img-transformation-container {
        display: none;
        background-repeat: no-repeat !important;
    }

    main {
        margin-top: 50px;
    }

    .main-container {
        width: 100% !important;
    }

    .img-result main {
        margin-top: 145px !important;
        padding: 20px 0 !important;
    }

    body {
        overflow-y: scroll;
    }

    .content-page {
        height: 100vh;
    }

    .page-container {
        height: -moz-fit-content !important;
        height: fit-content !important;
    }

    .header {
        border-radius: 0 !important;
        max-width: 100% !important;
        column-gap: 15px !important;
    }

    .main-title {
        font-size: 20px;
    }

    .sub-title {
        font-size: 15px;
    }

    .img-result {
        position: unset !important;
    }

    .adsbygoogle-left,
    .adsbygoogle-right {
        display: none !important;
        max-width: 0 !important;
    }

    .genbtn {
        min-width: 100%;
    }

    .btn-transfer-disabled {
        width: 100% !important;
    }

    .btn-transfer {
        width: 100% !important;
    }

    .image-container {
        align-self: center !important;
    }

    .top-ad {
        display: block !important;
    }

    .img-result-display img {
        height: var(--img-frame-max-width) !important;
        width: var(--img-frame-max-width) !important;
        border-radius: 8px;
        object-fit: contain !important;
        object-position: center;
    }

    .img-result-display {
        height: 700px !important;
        width: var(--img-frame-max-width) !important;
        max-width: var(--img-frame-max-width) !important;
        flex-direction: column !important;
        justify-content: unset !important;
    }

    .img-result-display>img:first-child {
        border-bottom-left-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }

    .img-result-display>img:nth-child(2) {
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
    }

    .concated {
        display: none !important;
    }

    .unconcated {
        display: flex !important;
    }

    .gallery-container .lazyload-wrapper,
    .gallery-container .gallery-item {
        width: 100% !important;
    }

    .gallery-container .lazyload-wrapper {
        height: -moz-fit-content !important;
        height: fit-content !important;
    }

    .qo-content {
        width: 100% !important;
    }

    .qo-content-text {
        width: 100% !important;
    }

    .qo-content img {
        width: 90% !important;
    }

    .qo-content-title-even {
        margin-top: 17.6px !important;
    }

    .slogan {
        font-size: .8rem !important;
    }

    .quick-overview-title {
        font-size: 1.5rem !important;
    }

    .qo-content-title {
        font-size: 1.2rem !important;
    }

    .portfolio-container {
        padding: 20px !important;
    }

    .qo-content-odd,
    .qo-content-even {
        font-size: 1rem !important;
    }

    .hash-tag a {
        font-size: 2rem !important;
    }

    .gallery-content {
        width: 100% !important;
        font-size: 1rem !important;
    }

    .banner {
        flex-flow: column !important;
        padding-bottom: 40px !important;
    }

    .banner-slogan,
    .banner-img {
        width: 100% !important;
        margin: 0 !important;
    }

    .baner-img {
        height: -moz-fit-content !important;
        height: fit-content !important;
    }

    .banner-btn {
        width: 60% !important;
    }

    .gallery-hr {
        display: block !important;
    }

    .gallery-try-btn {
        display: block !important;
    }

    .term-privacy {
        width: 100% !important;
    }

    .modal-base .CircularProgressbar {
        width: 25% !important;
    }

    .modal-base {
        top: 28% !important;
    }

    .hero-img {
        height: 360px !important;
        right: -25%;
    }

    .carousel-content {
        padding: 0 !important;
    }

    .carousel-content-text {
        width: 100% !important;
        padding: 0 !important;
        position: absolute;
        top: 0;

    }

    .header-logo {
        width: 30% !important;
    }

    .choose-hero-container {
        font-size: 10px !important;
    }

    .fs-container {
        width: 100% !important;
        margin-top: 100px !important;
    }

    .fs-component,
    .fs-tranform {
        flex-direction: column !important;
        height: 100% !important;
        width: 95% !important;
        margin: auto;
    }

    .fs-tranform-component {
        width: 100% !important;
    }

    .fs-selection {
        width: 100% !important;
        overflow: scroll !important;
    }

    .fs-gallery-container {
        flex-flow: row !important;
        overflow-y: unset !important;
        justify-content: flex-start !important;
        margin: 5px 10px;
        width: unset !important;
        padding-bottom: 0 !important;
    }

    .fs-tranform,
    .fs-selection {
        margin: 0 !important;
    }

    .fs-tranform {
        border: unset !important;
        row-gap: 15px;
        padding-top: 15px !important;
    }

    .fs-result-img {
        width: 100% !important;
    }

    .fs-result-img .fs-img-holder,
    .fs-result-img .fs-img-display {
        width: 100% !important;
        height: 100% !important;
        min-width: unset !important;
        max-width: unset !important;
    }

    .gallery-try-item {
        margin: 5px;
        height: -moz-fit-content;
        height: fit-content;

        .gallery-img {
            height: 100px !important;
            width: auto !important;
        }
    }

    .gallery-container-1 {
        .gallery-img {
            height: auto !important;
            width: 100%;
        }

        .fs-gallery-col {
            row-gap: 0 !important;
        }
    }

    .guide-step-container {
        flex-direction: column !important;
        gap: 30px;
        padding-bottom: 40px;

        .step-container {
            display: flex;
            width: 100% !important;
            flex-direction: row !important;
            gap: 15px;
        }

        .step-container:nth-of-type(even) {
            flex-direction: row-reverse !important;
        }

        .step-img {
            width: 100% !important;
            height: auto !important;
        }

        .step-text>* {
            margin: 0;
            align-self: start;
        }

        .step-text {
            h2 {
                font-size: 20px;
            }

            p {
                font-size: 16px;
                text-align: justify;
            }
        }
    }

    .target-image-container {
        align-self: flex-start;
        margin: 5px;

        .fs-img-holder,
        .fs-img-display {
            width: 100px !important;
            height: 100px !important;
        }
    }
}

/* opacity b0 */
.landing-header {
    position: fixed;
    width: 100%;
    z-index: 1000;
    top: 0;
}

.genbtn {
    width: 100%;
}

.header {
    background: hsla(0, 0%, 100%, .7);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    min-height: 56px;
    padding: 8px 20px;
    text-align: center;
    box-shadow: rgba(100, 100, 111, 0.4) 0px 0px 29px 0px;
    column-gap: 30px;
}

.login {
    display: flex;
    position: fixed;
    right: 2%;
    column-gap: 10px;
}

.login-button {
    background-color: #4285F4;
    /* Màu xanh đặc trưng của Google */
    border: none;
    color: white;
    padding: 10px 15px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 25px;
    transition: background-color 0.3s ease-in-out, transform 0.2s;
}

.login-button:hover {
    background-color: #357AE8;
    /* Màu xanh nhạt hơn khi rê chuột */
    transform: scale(1.05);
}

.login-button:active {
    background-color: #2A65C2;
    /* Màu xanh đậm hơn khi nhấn nút */
    transform: scale(1);
}

.google-icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
}

.login-button span {
    vertical-align: middle;
}

.css-hip9hq-MuiPaper-root-MuiAppBar-root {
    background-color: transparent !important;
}

.btn {
    cursor: pointer;
    border-radius: 5px;
    width: 100%;
    text-align: center;
    font-family: sans-serif;
    text-decoration: none;
    padding: 10px 0;
}

.btn-close {
    position: absolute;
    top: -1px;
    left: 5px;
    width: 25% !important;
    border: none !important;

    svg {
        fill: #c9cbce;
    }
}

.btn-primary {
    background-color: var(--primary-theme-color);
    padding: 10px 0;
    color: white;
    vertical-align: middle;
    font-family: sans-serif;
    font-weight: bold;
}

.btn-primary:hover,
.btn-transfer:hover {
    background-color: #4989a9bc;
}

.btn-transfer {
    border: 3px solid transparent;
    padding: 20px 0;
    background-color: #4989a9;
    vertical-align: middle;
    color: white;
    border-radius: 12px;
}

.display-flex {
    display: inline-flex;
    width: 100%;
    row-gap: 20px
}

.display-flex-row {
    flex-flow: row wrap;
}

.display-flex-col {
    flex-flow: column wrap;
}

.display-flex>* {
    flex: 1 1;
}

.adsbygoogle-left,
.adsbygoogle-right {
    max-width: 15% !important;
    height: auto;
    position: relative;
    max-height: 80%;
    align-self: center;
    min-height: 50%;
}

.adsbygoogle-center {
    width: auto;
    height: auto;
    align-self: center;
    margin: 30px 15px;
}

.adsbygoogle-bottom {
    max-width: 100% !important;
    max-height: 200px;
    min-height: 150px;
    align-self: self-end;
    padding: 10px;
}

.adsbygoogle-top {
    max-width: 100% !important;
    max-height: 150px;
    min-height: 100px;
    padding: 10px;
}

.top-ad {
    display: none;
}

.flex-bottom {
    justify-content: end;
}

.adsbygoogle>* {
    width: 100% !important;
}

.img-holder,
.img-display {
    height: var(--img-frame-max-width) !important;
    width: var(--img-frame-max-width) !important;
    max-width: var(--img-frame-max-width) !important;
    min-width: var(--img-frame-max-width) !important;
    border: 2px solid #fff !important;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.7);
    padding: 0 !important;
    box-shadow: rgba(100, 100, 111, 0.4) 0px 7px 29px 0px;
}

.img-result-display {
    height: var(--img-frame-max-width);
    width: 700px;
    max-width: 700px;
    border: 2px dashed var(--primary-theme-color);
    border-radius: 8px;
    margin-bottom: 10px;
    background-color: rgba(255, 255, 255, 0.5);

}

.img-display img {
    height: var(--img-frame-max-width);
    width: var(--img-frame-max-width);
    border-radius: 8px;
    object-fit: contain;
    object-position: center;
}

.img-result-display img {
    height: var(--img-frame-max-width);
    width: 700px;
    border-radius: 8px;
    object-fit: contain;
    object-position: center;
}

.img-display,
.fs-img-display,
.img-result-display,
.fs-img-result-display {
    position: relative;
    display: flex;
    justify-content: center;
}

.container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.CircularProgressbar {
    width: 40%;
    z-index: 99;
}

.circular-progress-bar {

    .CircularProgressbar-path,
    .CircularProgressbar-text {
        stroke: var(--progress-theme-color) !important;
        fill: var(--progress-theme-color) !important;
    }
}

.circular-progress-success {

    .CircularProgressbar-path,
    .CircularProgressbar-text {
        stroke: var(--success-theme-color) !important;
        fill: var(--success-theme-color) !important;
    }
}

.circular-progress-error {

    .CircularProgressbar-path,
    .CircularProgressbar-text {
        stroke: var(--error-theme-color) !important;
        fill: var(--error-theme-color) !important;
        font-family: sans-serif;
        font-size: 10px !important;
    }
}

.header-logo {
    width: 15%;
    cursor: pointer;
}

.title>* {
    width: -moz-fit-content;
    width: fit-content;
    margin: 0;
    display: inline-flex;
}

.title {
    padding-left: 5px;
}

.main-title {
    font-family: 'Kodchasan-Light';
    color: rgb(11, 3, 62);
    padding: 0 5px;
}

.sub-title {
    font-family: "Kodchasan-Bold";
    text-transform: uppercase;
}

.download,
.download-disabled {
    text-decoration: none;
    color: white;
}

.btn-disabled {
    pointer-events: none;
    background-color: gray;
    padding: 10px 0;
    color: white;
    vertical-align: middle;
}

.btn-transfer-disabled {
    pointer-events: none;
    background-color: gray;
    padding: 20px 0;
    color: white;
    vertical-align: middle;
    border-radius: 12px;
}

.download-disabled {
    pointer-events: none;
    cursor: default;
}

.image-container {
    row-gap: 15px;
}

.footer-container {
    text-align: center;
    width: auto !important;
    background-color: #f8f9fa;
    padding: 35px 15px;
    row-gap: 0;
}

.copy-right {
    color: #6c757d;
    font-weight: bold;
}

.author {
    text-decoration: none;
    color: var(--primary-theme-color);
    font-weight: lighter;
}

.link {
    text-decoration: none;
    color: var(--primary-theme-color);
    font-family: sans-serif;
    font-weight: bold;
}

.author:hover,
.link:hover {
    text-decoration: underline;
}

.question {
    margin: 30px;
    border-radius: 15px;
    background-color: white;
}

.question * {
    color: black;
    font-size: 2.8em;
}

.try-btn {
    background: linear-gradient(90deg, rgb(195 13 255) 0%, rgb(13, 134, 255) 50%, rgb(124, 200, 244) 100%);
    padding: 1.25rem 5rem;
    font-size: 1.5rem;
    font-weight: 700;
    text-transform: uppercase;
    border: 0;
    border-radius: 10rem;
    margin-bottom: 20px;
    color: white;
}

.try-btn:hover {
    cursor: pointer;
    background-color: var(--primary-theme-color-hover);
}

.portfolio * {
    font-family: sans-serif;
}

.language {
    margin-left: auto;
    display: flex;
    justify-content: center;
}

.lang-btn,
.share-btn {
    cursor: pointer;
    background-color: transparent;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

.lang-btn>span {
    margin-top: 3px;
    font-family: "Kodchasan-Bold";
}

.lang-btn:hover {
    text-decoration: underline;
}

.flag {
    width: 20px;
    height: 20px;
    margin: 0 5px;
}

.concated {
    display: flex;
}

.unconcated {
    display: none;
}

.share-btn {
    color: white;
    background-color: #3b5998;
    padding: 5px;
    justify-content: flex-start;
    padding-left: 10px;
}

.share-btn>span {
    font-family: sans-serif;
    margin: auto;
    font-weight: bold;
}

.quick-overview-title {
    font-size: 2.8em;
    color: var(--primary-theme-color);
    margin: 0;
    font-weight: bold;
    text-align: center;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.qo-content {
    display: flex;
    width: 80%;
    flex-flow: row wrap;
    border-radius: 5px;
    padding-bottom: 100px;
    margin: auto;
}

.qo-content img {
    width: 40%;
    border-radius: 5px;
    margin: auto;
}

.qo-content-text {
    width: 50%;
    margin: 0;
    padding: 0 20px;
}

.qo-content-title {
    margin: 0;
    text-align: left;
}

/* .qo-content:nth-of-type(odd){
	border-left: 5px solid var(--primary-theme-color);
}
.qo-content:nth-of-type(even){
	border-right: 5px solid var(--primary-theme-color);
} */
.qo-content-odd,
.qo-content-even {
    text-align: justify;
    font-size: 1.2rem;
    font-family: sans-serif
}

.qo-content-title-even {
    margin-top: 0;
}

.qo-content-2 {
    margin-left: auto;
}

.hash-tag a {
    color: var(--primary-theme-color);
    text-decoration: unset;
    font-size: 2.5rem;
}

.hash-tag a:hover {
    text-decoration: underline;
}

.gallery-container {
    display: flex;
    flex-flow: row wrap;
    flex-direction: row;
    width: 100%;

    .gallery-item {
        margin: 5px;
        width: 32%;
    }

    .gallery-try-item {
        height: -moz-fit-content;
        height: fit-content;
        align-self: flex-start;

        .gallery-img {
            height: auto;
            width: 90%;
        }
    }

    .lazyload-wrapper {
        width: 100%;
        height: 100%;
    }

    .gallery-img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
        cursor: pointer;
    }
}

.gallery-content {
    width: 60%;
    font-size: 1.2rem;
    font-family: sans-serif;
    margin-top: 0;
}

.slogan {
    color: white;
    margin: 0 12px;
    background-color: var(--primary-theme-color);
    border-radius: 20px;
    font-size: 1.1rem;
    width: 87%;
    text-align: left;
    padding: 5px 10px;
    margin-bottom: 10px;
    font-family: 'Kodchasan-Light';
}

.banner {
    background-color: var(--primary-theme-color);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
    padding: 160px 20px 0 20px;
    height: 70%;
    width: -moz-fit-content;
    width: fit-content;
}

.banner * {
    color: white;
    font-family: "Poppins", Sans-serif;
    margin: 10px;
}

.banner .banner-slogan {
    width: 50%;
    margin: 10px 80px;
}

.banner h1 {
    font-size: 3rem;
    margin-bottom: 5px;
}

.banner .slogan1 {
    font-size: 1.7rem;
}

.banner .slogan2 {
    font-size: 1.2rem;
}

.banner .banner-btn {
    display: flex;
    background-color: white;
    border-radius: 5px;
    cursor: pointer;
    width: 40%;
    margin: 20px 10px;
    border: 2px solid #fff;
}

.banner .banner-btn p {
    background-image: linear-gradient(to bottom right, #dc6bfe, #69b1ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 15px auto;
    font-weight: bold;
    font-size: large;
}

.banner .banner-btn:hover {
    background-color: transparent;
}

.banner .banner-btn:hover p {
    background-image: none;
    -webkit-text-fill-color: white;
}

.banner .banner-img {
    width: 50%;
    height: var(--img-frame-max-width);
}

.banner .banner-img img {
    width: 20%;
    border-radius: 5px;
}

.banner .banner-img img:nth-of-type(odd) {
    align-self: self-start;
}

.banner .banner-img img:nth-of-type(even) {
    align-self: center;
}

.gallery-try-btn,
.fs-try-btn {
    background: linear-gradient(90deg, rgb(195 13 255) 0%, rgb(13, 134, 255) 50%, rgb(124, 200, 244) 100%);
    padding: 1rem 9rem;
    font-size: 1rem;
    font-weight: 500;
    text-transform: uppercase;
    border: 0;
    border-radius: 10rem;
    margin: auto;
    margin-top: 12px;
    color: white;
}

.gallery-try-btn {
    display: none;
}

/* .keyword {
    color: var(--primary-theme-color);
    font-family: sans-serif;
} */

.term-content {
    margin-top: 150px;
    text-align: justify;
}

.term-content .keyword {
    font-family: sans-serif;
    font-weight: bold;
}

.term-table {
    width: 85%;
    margin: auto;
}

.term-table .table-head,
.term-table .table-title {
    color: var(--primary-theme-color);
    margin-bottom: 0;
    margin-top: 5px;
}

/* .term-table .table-sub-title {
    font-style: italic;
} */
.title-letter,
.li-letter {
    width: 5%;
}

.li-letter {
    font-size: 20px;
}

.term-table ol {
    margin: 0;
}

.term-table li {
    margin: 6px 0;
}

.term-table tr {
    vertical-align: top;
}

.term-container {
    background-color: #f1f1f1;
    padding-bottom: 20px;
}

.back-btn {
    margin: 20px 0;
    padding: 15px 0;
    background-color: var(--primary-theme-color);
    color: white;
    font-size: large;
    max-width: var(--img-frame-max-width);
}

.back-btn:hover {
    background-color: var(--primary-theme-color-hover);
}

.term-privacy {
    width: 45%;
}

.modal-base {
    top: 20%;
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border-radius: 10px;
    width: 75%;
    opacity: 0;
    transition: all 0.2s ease-in-out;
    transform: scale(0.8);
    text-align: center;
}

.modal-base .CircularProgressbar {
    width: 10%;
}

.modal-base_after-open {
    opacity: 1;
    transform: scale(1);
}

.modal-base_before-close {
    transform: scale(.2);
    opacity: 0;
}

.overlay-base {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(66, 66, 66, .5);
    opacity: 0;
    transition: all 0.3s ease-out;
    z-index: 101;
}

.overlay-base_after-open {
    opacity: 1;
}

.overlay-base_before-close {
    opacity: 0;
}

.text-bold {
    font-weight: bold;
}

.close-pop-up {
    margin: 0;
}

.social-media-btn {
    padding: 5px;
    margin: 10px;
    border: none;
    cursor: pointer;
    text-decoration: none;
    color: #fff;
    width: 100%;
}

.social-media-icon {
    width: 40px !important;
}

.social-media-icon-container {
    display: inline-flex;
    width: 100%;
    justify-content: flex-start;
}

.social-media-icon-id {
    margin: auto;
    padding-right: 40px;
}

.transform-btn-container {
    max-width: var(--img-frame-max-width);
    justify-content: space-between;
}

.transform-btn-container>* {
    max-width: 48%;
}

.share-btn-container {
    max-width: 600px;
    justify-content: space-between;
    padding: 20px;
}

.share-btn-container>* {
    max-width: 40%;
    height: 30px;
}

.jWkLDY>span {
    font-size: 10px !important;
    display: none;
}

.guZdik {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    padding: 0 !important;
    border: none !important;
}

.image-container {
    .guZdik {
        height: var(--src-img-frame-max-width) !important;
    }
}

.drag-drop-img>svg {
    margin-left: 10px !important;
    display: none;
}

.trial-img-container {
    max-width: var(--img-frame-max-width);
    justify-content: space-between;
}

.no-img-text {
    width: 34%;
    /* color: #54616c; */
    color: #fff;
    font-weight: 600;
    font-size: 13px;
}

.trial-text {
    color: #54616c;
    font-weight: 600;
}

.trial-img {
    width: 65%;
    justify-content: space-between;
}

.trial-img img {
    max-width: 22%;
    border-radius: 5px;
    cursor: pointer;
}

.trial-img img:hover {
    opacity: 0.9;
}

.img-result {
    position: relative;
    top: 150px;
}

.btn-list-contanier {
    width: 100%;
    max-width: var(--result-img-frame-max-width);
    background-color: white;
    border-radius: 5px;
    margin: auto;
}

.btn-list-contanier .btn {
    border-radius: unset;
    border: unset;
    border-right: solid 0.5px var(--primary-theme-color);
}

.btn-list-contanier .btn:last-child {
    border-right: unset !important;
}

.btn-icon {
    padding-right: 10px;
}

.btn-label {
    font-size: small;
}

.banner-hero {
    width: 70%;
    max-width: 70%;
    margin: auto;
}

.icon-left {
    left: 0px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

.icon-right {
    right: 0px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

.carousel-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 100;
    font-size: 30px;
    color: white;
    padding: 40px 10px;
    cursor: pointer;
    background: rgba(77, 75, 75, 0.8);
}

.carousel-content {
    display: flex;
    border-radius: 20px;
    position: relative;
    flex-direction: column;
    height: 400px;
    justify-content: center;
    padding: 0 60px;
    background-size: cover;
}

.hero-banner-title {
    margin: 0;
    position: relative;
    z-index: 1;
}

.carousel-content-text {
    width: 80%;
    text-align: justify;
    color: white;
    padding: 15px;
    /* background-color: rgba(77, 75, 75, 0.8); */
    border-radius: 5px;
}

.carousel-content-title {
    font-size: 40px;
    padding: 0;
    margin: 0;
}

.hero-img {
    height: 460px;
    position: absolute;
    right: -15%;
    bottom: 0;
}

.carousel-item {
    position: relative;
}

.flex-start {
    justify-content: flex-start;
}

.choose-hero-icon-container {
    position: relative;
    padding: 10px;
}

.choose-hero-container {
    background-color: var(--primary-theme-color);
    position: relative;
    top: 16px;
    color: white;
    padding: 0 10px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.choose-hero-title {
    margin-top: 10px !important;
    margin-bottom: 26px !important;
}

.hero-logo {
    width: 70%;
}

.try-again {
    color: var(--primary-theme-color);
    font-weight: bold;
}

.tool-tip {
    background: #f5f5f5c2;
    width: 100%;
    padding: 5px 0;
    border-radius: 5px;
    border: solid 1px transparent;
    align-items: start;
    justify-content: flex-start;
}

.tool-tip>i {
    padding-left: 5px;
    top: 4px;
    position: relative;
}

.tooltip-text {
    padding: 0 8px;
}

.fs-container {
    width: 90%;
    margin: auto;
}

.fs-component {
    background-color: white;
    border-radius: 10px;
    width: 100%;
    height: 400px;
    margin-top: 20px;
}

.fs-tranform {
    width: 70%;
    height: 100%;
    border-right: 2px solid #f2f4f5;
    margin-right: 0 !important;
}

.fs-selection {
    width: 35%;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
}

.fs-tranform,
.fs-selection {
    margin: 20px;
}

.fs-tranform-component {
    width: 55%;
    row-gap: 10px;
    height: 325px;
    justify-content: space-between;
}

.fs-result-img {
    width: 45%;
}

.fs-result-img .fs-img-holder,
.fs-result-img .fs-img-display {
    width: var(--result-img-frame-max-width) !important;
    height: var(--result-img-frame-max-width) !important;
    max-width: var(--result-img-frame-max-width) !important;
    min-width: var(--result-img-frame-max-width) !important;
    border: 2px dashed gray;
    border-radius: 20px;
    margin-bottom: 10px;
}

.fs-result-img .fs-img-display img {
    height: var(--result-img-frame-max-width) !important;
    width: var(--result-img-frame-max-width) !important;

}

.fs-img-holder,
.fs-img-display {
    width: var(--src-img-frame-max-width);
    height: var(--src-img-frame-max-width);
    max-width: var(--src-img-frame-max-width) !important;
    min-width: var(--src-img-frame-max-width) !important;
}

.fs-img-display img {
    height: var(--src-img-frame-max-width) !important;
    width: var(--src-img-frame-max-width) !important;
    border-radius: 20px;
    object-fit: contain;
    object-position: center;
}

.fs-tranform-img-container {
    width: 100%;
    justify-content: space-between;
}

.fs-tranform-tool {
    row-gap: 10px;
}

.fs-gallery-container {
    justify-content: center;
    overflow-y: scroll;
    height: 90%;
    padding: 10px 0;
}

.gallery-try-item-active {
    border: #17f952 4px solid;
}

.main-component {
    margin-top: 125px;
}

.hover-menu {
    padding: 0.5rem 1rem;
}

.fs-gallery-col {
    justify-content: flex-start;
    width: 30%;
    row-gap: 10px;
}

.guide-step-container {
    display: flex;
    width: 90%;
    justify-content: space-between;
    margin: auto;
}

.step-container {
    width: 30%;
}

.step-img img {
    width: 100%;
    border-radius: 20px;
    height: 100%;
}

.step-img {
    height: 400px;
}

.step1 img {
    height: unset;
}

.fs-title {
    margin-top: 75px;
    margin-bottom: 30px;
}

.step-text {
    flex-direction: column;
    align-items: flex-start;
}

.howtofs {
    padding-bottom: 20px;
}

.menu-item {
    text-decoration: none;
    color: #000;
}

.button-hide {
    .btn {
        cursor: default;
    }

    color: gray;
}

.button-show {
    color: unset;

    .btn {
        cursor: pointer;
    }
}

.w-32 {
    width: 32% !important;
}

.w-49 {
    width: 49% !important;
}

.w-24 {
    width: 24% !important;
}

.gallery-container-1 {
    justify-content: space-between;

    .gallery-img {
        width: 100% !important;
    }

    .fs-gallery-col {
        row-gap: 20px;
    }
}

.target-image-container {
    width: 100%;
    height: 2%;
    justify-content: flex-start;

    .fs-img-holder,
    .fs-img-display {
        min-width: 88% !important;
        max-width: none !important;
        width: 88%;
        height: 86%;
        justify-content: flex-start;
    }

    .fs-img-display img {
        width: 88% !important;
        height: 120px !important;
    }

    .guZdik {
        border: #000 dashed 2px !important;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
        border-radius: 15px;
        flex-direction: row;
        align-self: flex-start;
    }
}

.hidden {
    display: none;
}

img.user-avatar {
    border-radius: 50%;
    width: 15%;
}

.user-info {
    column-gap: 10px;
    justify-content: flex-end;
    max-width: 235px;
}
.sub-text {
    text-align: center;
    padding: 0 15px;
}

.navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.menu {
    display: none;
}

.menu a {
    text-decoration: none;
    padding: 10px;
    display: block;
    text-align: start;
}

.hamburger {
    cursor: pointer;
    display: block;
}

.hamburger div {
    width: 25px;
    height: 3px;
    background-color: #5993b1;
    margin: 5px 0;
    border-radius: 10px;
}

.menu.open {
    display: block;
}

@media (min-width: 768px) {
    .menu {
        display: flex;
    }

    .logout {
        display: inline-flex !important;
    }
    .navbar,.hamburger {
        display: none;
    }
}
.logout {
    display: none;
    padding-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,4BAA4B;IAC5B,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;IACZ,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,4CAAuD;IACvD,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,4CAAyD;AAC7D;;AAEA;IACI,6BAA6B;IAC7B,4CAAwD;AAC5D;;AAEA;IACI,8BAA8B;IAC9B,4CAAyD;AAC7D;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI;QACI,aAAa;QACb,uCAAuC;IAC3C;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,4BAA4B;QAC5B,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mCAA8B;QAA9B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,wBAAwB;QACxB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6CAA6C;QAC7C,4CAA4C;QAC5C,kBAAkB;QAClB,8BAA8B;QAC9B,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;QACxB,4CAA4C;QAC5C,gDAAgD;QAChD,iCAAiC;QACjC,iCAAiC;IACrC;;IAEA;QACI,uCAAuC;QACvC,wCAAwC;IAC5C;;IAEA;QACI,oCAAoC;QACpC,qCAAqC;IACzC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,mCAA8B;QAA9B,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;QAC5B,+BAA+B;IACnC;;IAEA;;QAEI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,mCAA8B;QAA9B,8BAA8B;IAClC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;QACxB,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,qBAAqB;QACrB,kBAAkB;QAClB,MAAM;;IAEV;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;;QAEI,iCAAiC;QACjC,uBAAuB;QACvB,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;QAC5B,sCAAsC;QACtC,gBAAgB;QAChB,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;;QAEI,oBAAoB;IACxB;;IAEA;QACI,wBAAwB;QACxB,aAAa;QACb,4BAA4B;IAChC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;QACtB,uBAAuB;QACvB,2BAA2B;QAC3B,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,wBAAmB;QAAnB,mBAAmB;;QAEnB;YACI,wBAAwB;YACxB,sBAAsB;QAC1B;IACJ;;IAEA;QACI;YACI,uBAAuB;YACvB,WAAW;QACf;;QAEA;YACI,qBAAqB;QACzB;IACJ;;IAEA;QACI,iCAAiC;QACjC,SAAS;QACT,oBAAoB;;QAEpB;YACI,aAAa;YACb,sBAAsB;YACtB,8BAA8B;YAC9B,SAAS;QACb;;QAEA;YACI,sCAAsC;QAC1C;;QAEA;YACI,sBAAsB;YACtB,uBAAuB;QAC3B;;QAEA;YACI,SAAS;YACT,iBAAiB;QACrB;;QAEA;YACI;gBACI,eAAe;YACnB;;YAEA;gBACI,eAAe;gBACf,mBAAmB;YACvB;QACJ;IACJ;;IAEA;QACI,sBAAsB;QACtB,WAAW;;QAEX;;YAEI,uBAAuB;YACvB,wBAAwB;QAC5B;IACJ;AACJ;;AAEA,eAAe;AACf;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,MAAM;AACV;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,qDAAqD;IACrD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,6DAA6D;AACjE;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,qBAAqB;IACrB,uBAAuB;;IAEvB;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAO;AACX;;AAEA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,6CAA6C;IAC7C,4CAA4C;IAC5C,gDAAgD;IAChD,gDAAgD;IAChD,iCAAiC;IACjC,kBAAkB;IAClB,0CAA0C;IAC1C,qBAAqB;IACrB,qDAAqD;AACzD;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;IAChB,6CAA6C;IAC7C,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;;AAE9C;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;;;IAII,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI;;QAEI,8CAA8C;QAC9C,4CAA4C;IAChD;AACJ;;AAEA;;IAEI;;QAEI,6CAA6C;QAC7C,2CAA2C;IAC/C;AACJ;;AAEA;;IAEI;;QAEI,2CAA2C;QAC3C,yCAAyC;QACzC,uBAAuB;QACvB,0BAA0B;IAC9B;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;IACjC,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,sGAAsG;IACtG,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;;;;;GAKG;AACH;;IAEI,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;;IAEX;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,wBAAmB;QAAnB,mBAAmB;QACnB,sBAAsB;;QAEtB;YACI,YAAY;YACZ,UAAU;QACd;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,eAAe;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,4CAA4C;IAC5C,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,4CAA4C;IAC5C,yDAAuE;IACvE,sBAAsB;IACtB,0BAA0B;IAC1B,WAAW;IACX,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,oEAAoE;IACpE,6BAA6B;IAC7B,oCAAoC;IACpC,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,sGAAsG;IACtG,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,SAAS;IACT,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;GAGG;;AAEH;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;GAEG;AACH;;IAEI,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,4CAA4C;IAC5C,YAAY;IACZ,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,UAAU;IAEV,gCAAgC;IAChC,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sCAAsC;IACtC,UAAU;IACV,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,yDAAyD;IACzD,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI;QACI,iDAAiD;IACrD;AACJ;;AAEA;IACI,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,4CAA4C;IAC5C,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,oDAAoD;AACxD;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,mDAAmD;IACnD,oDAAoD;IACpD,uDAAuD;IACvD,uDAAuD;IACvD,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,oDAAoD;IACpD,mDAAmD;;AAEvD;;AAEA;;IAEI,qCAAqC;IACrC,sCAAsC;IACtC,oDAAoD;IACpD,oDAAoD;AACxD;;AAEA;IACI,iDAAiD;IACjD,gDAAgD;IAChD,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA,WAAW;AACf;;AAEA;IACI,YAAY;;IAEZ;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;;IAE9B;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,UAAU;IACV,2BAA2B;;IAE3B;;QAEI,yBAAyB;QACzB,0BAA0B;QAC1B,UAAU;QACV,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,qBAAqB;QACrB,wBAAwB;IAC5B;;IAEA;QACI,kCAAkC;QAClC,yDAAoD;QACpD,mBAAmB;QACnB,mBAAmB;QACnB,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,+BAA+B;IACnC;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":["html {\n    --primary-theme-color: #555;\n    --primary-theme-color-hover: #555;\n    --error-theme-color: #d03a40;\n    --success-theme-color: #2eae5b;\n    --progress-theme-color: #318ac6;\n    --img-frame-max-width: 250px;\n    --result-img-frame-max-width: 280px;\n    --src-img-frame-max-width: 160px;\n}\n\n.page-container {\n    height: 100% !important;\n}\n\nhtml,\nbody {\n    height: 100%;\n    margin: 0;\n    background-color: #f2f4f5;\n}\n\nhr {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n    width: 75%;\n}\n\n.gallery-hr {\n    display: none;\n}\n\n@font-face {\n    font-family: \"PermanentMarker\";\n    src: url(\"../assets/fonts/PermanentMarker-Regular.ttf\");\n    font-weight: bold;\n}\n\n@font-face {\n    font-family: \"Kodchasan-Light\";\n    src: url(\"../assets/fonts/Kodchasan/Kodchasan-Light.ttf\");\n}\n\n@font-face {\n    font-family: \"Kodchasan-Bold\";\n    src: url(\"../assets/fonts/Kodchasan/Kodchasan-Bold.ttf\");\n}\n\n@font-face {\n    font-family: \"Kodchasan-Light\";\n    src: url(\"../assets/fonts/Kodchasan/Kodchasan-Light.ttf\");\n}\n\n.main-container {\n    width: 70% !important;\n    padding: 100px 0;\n}\n\n.img-transformation-container {\n    display: none;\n    background-size: cover;\n}\n\n.portfolio-container {\n    text-align: center;\n    padding: 50px;\n    width: auto !important;\n}\n\n::-webkit-scrollbar {\n    display: none;\n}\n\n@media (max-width: 1038px) {\n\n\n    .img-transformation-container {\n        display: none;\n        background-repeat: no-repeat !important;\n    }\n\n    main {\n        margin-top: 50px;\n    }\n\n    .main-container {\n        width: 100% !important;\n    }\n\n    .img-result main {\n        margin-top: 145px !important;\n        padding: 20px 0 !important;\n    }\n\n    body {\n        overflow-y: scroll;\n    }\n\n    .content-page {\n        height: 100vh;\n    }\n\n    .page-container {\n        height: fit-content !important;\n    }\n\n    .header {\n        border-radius: 0 !important;\n        max-width: 100% !important;\n        column-gap: 15px !important;\n    }\n\n    .main-title {\n        font-size: 20px;\n    }\n\n    .sub-title {\n        font-size: 15px;\n    }\n\n    .img-result {\n        position: unset !important;\n    }\n\n    .adsbygoogle-left,\n    .adsbygoogle-right {\n        display: none !important;\n        max-width: 0 !important;\n    }\n\n    .genbtn {\n        min-width: 100%;\n    }\n\n    .btn-transfer-disabled {\n        width: 100% !important;\n    }\n\n    .btn-transfer {\n        width: 100% !important;\n    }\n\n    .image-container {\n        align-self: center !important;\n    }\n\n    .top-ad {\n        display: block !important;\n    }\n\n    .img-result-display img {\n        height: var(--img-frame-max-width) !important;\n        width: var(--img-frame-max-width) !important;\n        border-radius: 8px;\n        object-fit: contain !important;\n        object-position: center;\n    }\n\n    .img-result-display {\n        height: 700px !important;\n        width: var(--img-frame-max-width) !important;\n        max-width: var(--img-frame-max-width) !important;\n        flex-direction: column !important;\n        justify-content: unset !important;\n    }\n\n    .img-result-display>img:first-child {\n        border-bottom-left-radius: 0 !important;\n        border-bottom-right-radius: 0 !important;\n    }\n\n    .img-result-display>img:nth-child(2) {\n        border-top-left-radius: 0 !important;\n        border-top-right-radius: 0 !important;\n    }\n\n    .concated {\n        display: none !important;\n    }\n\n    .unconcated {\n        display: flex !important;\n    }\n\n    .gallery-container .lazyload-wrapper,\n    .gallery-container .gallery-item {\n        width: 100% !important;\n    }\n\n    .gallery-container .lazyload-wrapper {\n        height: fit-content !important;\n    }\n\n    .qo-content {\n        width: 100% !important;\n    }\n\n    .qo-content-text {\n        width: 100% !important;\n    }\n\n    .qo-content img {\n        width: 90% !important;\n    }\n\n    .qo-content-title-even {\n        margin-top: 17.6px !important;\n    }\n\n    .slogan {\n        font-size: .8rem !important;\n    }\n\n    .quick-overview-title {\n        font-size: 1.5rem !important;\n    }\n\n    .qo-content-title {\n        font-size: 1.2rem !important;\n    }\n\n    .portfolio-container {\n        padding: 20px !important;\n    }\n\n    .qo-content-odd,\n    .qo-content-even {\n        font-size: 1rem !important;\n    }\n\n    .hash-tag a {\n        font-size: 2rem !important;\n    }\n\n    .gallery-content {\n        width: 100% !important;\n        font-size: 1rem !important;\n    }\n\n    .banner {\n        flex-flow: column !important;\n        padding-bottom: 40px !important;\n    }\n\n    .banner-slogan,\n    .banner-img {\n        width: 100% !important;\n        margin: 0 !important;\n    }\n\n    .baner-img {\n        height: fit-content !important;\n    }\n\n    .banner-btn {\n        width: 60% !important;\n    }\n\n    .gallery-hr {\n        display: block !important;\n    }\n\n    .gallery-try-btn {\n        display: block !important;\n    }\n\n    .term-privacy {\n        width: 100% !important;\n    }\n\n    .modal-base .CircularProgressbar {\n        width: 25% !important;\n    }\n\n    .modal-base {\n        top: 28% !important;\n    }\n\n    .hero-img {\n        height: 360px !important;\n        right: -25%;\n    }\n\n    .carousel-content {\n        padding: 0 !important;\n    }\n\n    .carousel-content-text {\n        width: 100% !important;\n        padding: 0 !important;\n        position: absolute;\n        top: 0;\n\n    }\n\n    .header-logo {\n        width: 30% !important;\n    }\n\n    .choose-hero-container {\n        font-size: 10px !important;\n    }\n\n    .fs-container {\n        width: 100% !important;\n        margin-top: 100px !important;\n    }\n\n    .fs-component,\n    .fs-tranform {\n        flex-direction: column !important;\n        height: 100% !important;\n        width: 95% !important;\n        margin: auto;\n    }\n\n    .fs-tranform-component {\n        width: 100% !important;\n    }\n\n    .fs-selection {\n        width: 100% !important;\n        overflow: scroll !important;\n    }\n\n    .fs-gallery-container {\n        flex-flow: row !important;\n        overflow-y: unset !important;\n        justify-content: flex-start !important;\n        margin: 5px 10px;\n        width: unset !important;\n        padding-bottom: 0 !important;\n    }\n\n    .fs-tranform,\n    .fs-selection {\n        margin: 0 !important;\n    }\n\n    .fs-tranform {\n        border: unset !important;\n        row-gap: 15px;\n        padding-top: 15px !important;\n    }\n\n    .fs-result-img {\n        width: 100% !important;\n    }\n\n    .fs-result-img .fs-img-holder,\n    .fs-result-img .fs-img-display {\n        width: 100% !important;\n        height: 100% !important;\n        min-width: unset !important;\n        max-width: unset !important;\n    }\n\n    .gallery-try-item {\n        margin: 5px;\n        height: fit-content;\n\n        .gallery-img {\n            height: 100px !important;\n            width: auto !important;\n        }\n    }\n\n    .gallery-container-1 {\n        .gallery-img {\n            height: auto !important;\n            width: 100%;\n        }\n\n        .fs-gallery-col {\n            row-gap: 0 !important;\n        }\n    }\n\n    .guide-step-container {\n        flex-direction: column !important;\n        gap: 30px;\n        padding-bottom: 40px;\n\n        .step-container {\n            display: flex;\n            width: 100% !important;\n            flex-direction: row !important;\n            gap: 15px;\n        }\n\n        .step-container:nth-of-type(even) {\n            flex-direction: row-reverse !important;\n        }\n\n        .step-img {\n            width: 100% !important;\n            height: auto !important;\n        }\n\n        .step-text>* {\n            margin: 0;\n            align-self: start;\n        }\n\n        .step-text {\n            h2 {\n                font-size: 20px;\n            }\n\n            p {\n                font-size: 16px;\n                text-align: justify;\n            }\n        }\n    }\n\n    .target-image-container {\n        align-self: flex-start;\n        margin: 5px;\n\n        .fs-img-holder,\n        .fs-img-display {\n            width: 100px !important;\n            height: 100px !important;\n        }\n    }\n}\n\n/* opacity b0 */\n.landing-header {\n    position: fixed;\n    width: 100%;\n    z-index: 1000;\n    top: 0;\n}\n\n.genbtn {\n    width: 100%;\n}\n\n.header {\n    background: hsla(0, 0%, 100%, .7);\n    -webkit-backdrop-filter: blur(20px);\n    backdrop-filter: blur(20px);\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n    margin-right: auto;\n    min-height: 56px;\n    padding: 8px 20px;\n    text-align: center;\n    box-shadow: rgba(100, 100, 111, 0.4) 0px 0px 29px 0px;\n    column-gap: 30px;\n}\n\n.login {\n    display: flex;\n    position: fixed;\n    right: 2%;\n    column-gap: 10px;\n}\n\n.login-button {\n    background-color: #4285F4;\n    /* Màu xanh đặc trưng của Google */\n    border: none;\n    color: white;\n    padding: 10px 15px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 25px;\n    transition: background-color 0.3s ease-in-out, transform 0.2s;\n}\n\n.login-button:hover {\n    background-color: #357AE8;\n    /* Màu xanh nhạt hơn khi rê chuột */\n    transform: scale(1.05);\n}\n\n.login-button:active {\n    background-color: #2A65C2;\n    /* Màu xanh đậm hơn khi nhấn nút */\n    transform: scale(1);\n}\n\n.google-icon {\n    display: inline-block;\n    vertical-align: middle;\n    margin-right: 8px;\n}\n\n.login-button span {\n    vertical-align: middle;\n}\n\n.css-hip9hq-MuiPaper-root-MuiAppBar-root {\n    background-color: transparent !important;\n}\n\n.btn {\n    cursor: pointer;\n    border-radius: 5px;\n    width: 100%;\n    text-align: center;\n    font-family: sans-serif;\n    text-decoration: none;\n    padding: 10px 0;\n}\n\n.btn-close {\n    position: absolute;\n    top: -1px;\n    left: 5px;\n    width: 25% !important;\n    border: none !important;\n\n    svg {\n        fill: #c9cbce;\n    }\n}\n\n.btn-primary {\n    background-color: var(--primary-theme-color);\n    padding: 10px 0;\n    color: white;\n    vertical-align: middle;\n    font-family: sans-serif;\n    font-weight: bold;\n}\n\n.btn-primary:hover,\n.btn-transfer:hover {\n    background-color: #4989a9bc;\n}\n\n.btn-transfer {\n    border: 3px solid transparent;\n    padding: 20px 0;\n    background-color: #4989a9;\n    vertical-align: middle;\n    color: white;\n    border-radius: 12px;\n}\n\n.display-flex {\n    display: inline-flex;\n    width: 100%;\n    row-gap: 20px\n}\n\n.display-flex-row {\n    flex-flow: row wrap;\n}\n\n.display-flex-col {\n    flex-flow: column wrap;\n}\n\n.display-flex>* {\n    flex: 1;\n}\n\n.adsbygoogle-left,\n.adsbygoogle-right {\n    max-width: 15% !important;\n    height: auto;\n    position: relative;\n    max-height: 80%;\n    align-self: center;\n    min-height: 50%;\n}\n\n.adsbygoogle-center {\n    width: auto;\n    height: auto;\n    align-self: center;\n    margin: 30px 15px;\n}\n\n.adsbygoogle-bottom {\n    max-width: 100% !important;\n    max-height: 200px;\n    min-height: 150px;\n    align-self: self-end;\n    padding: 10px;\n}\n\n.adsbygoogle-top {\n    max-width: 100% !important;\n    max-height: 150px;\n    min-height: 100px;\n    padding: 10px;\n}\n\n.top-ad {\n    display: none;\n}\n\n.flex-bottom {\n    justify-content: end;\n}\n\n.adsbygoogle>* {\n    width: 100% !important;\n}\n\n.img-holder,\n.img-display {\n    height: var(--img-frame-max-width) !important;\n    width: var(--img-frame-max-width) !important;\n    max-width: var(--img-frame-max-width) !important;\n    min-width: var(--img-frame-max-width) !important;\n    border: 2px solid #fff !important;\n    border-radius: 8px;\n    background-color: rgba(255, 255, 255, 0.7);\n    padding: 0 !important;\n    box-shadow: rgba(100, 100, 111, 0.4) 0px 7px 29px 0px;\n}\n\n.img-result-display {\n    height: var(--img-frame-max-width);\n    width: 700px;\n    max-width: 700px;\n    border: 2px dashed var(--primary-theme-color);\n    border-radius: 8px;\n    margin-bottom: 10px;\n    background-color: rgba(255, 255, 255, 0.5);\n\n}\n\n.img-display img {\n    height: var(--img-frame-max-width);\n    width: var(--img-frame-max-width);\n    border-radius: 8px;\n    object-fit: contain;\n    object-position: center;\n}\n\n.img-result-display img {\n    height: var(--img-frame-max-width);\n    width: 700px;\n    border-radius: 8px;\n    object-fit: contain;\n    object-position: center;\n}\n\n.img-display,\n.fs-img-display,\n.img-result-display,\n.fs-img-result-display {\n    position: relative;\n    display: flex;\n    justify-content: center;\n}\n\n.container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.CircularProgressbar {\n    width: 40%;\n    z-index: 99;\n}\n\n.circular-progress-bar {\n\n    .CircularProgressbar-path,\n    .CircularProgressbar-text {\n        stroke: var(--progress-theme-color) !important;\n        fill: var(--progress-theme-color) !important;\n    }\n}\n\n.circular-progress-success {\n\n    .CircularProgressbar-path,\n    .CircularProgressbar-text {\n        stroke: var(--success-theme-color) !important;\n        fill: var(--success-theme-color) !important;\n    }\n}\n\n.circular-progress-error {\n\n    .CircularProgressbar-path,\n    .CircularProgressbar-text {\n        stroke: var(--error-theme-color) !important;\n        fill: var(--error-theme-color) !important;\n        font-family: sans-serif;\n        font-size: 10px !important;\n    }\n}\n\n.header-logo {\n    width: 15%;\n    cursor: pointer;\n}\n\n.title>* {\n    width: fit-content;\n    margin: 0;\n    display: inline-flex;\n}\n\n.title {\n    padding-left: 5px;\n}\n\n.main-title {\n    font-family: 'Kodchasan-Light';\n    color: rgb(11, 3, 62);\n    padding: 0 5px;\n}\n\n.sub-title {\n    font-family: \"Kodchasan-Bold\";\n    text-transform: uppercase;\n}\n\n.download,\n.download-disabled {\n    text-decoration: none;\n    color: white;\n}\n\n.btn-disabled {\n    pointer-events: none;\n    background-color: gray;\n    padding: 10px 0;\n    color: white;\n    vertical-align: middle;\n}\n\n.btn-transfer-disabled {\n    pointer-events: none;\n    background-color: gray;\n    padding: 20px 0;\n    color: white;\n    vertical-align: middle;\n    border-radius: 12px;\n}\n\n.download-disabled {\n    pointer-events: none;\n    cursor: default;\n}\n\n.image-container {\n    row-gap: 15px;\n}\n\n.footer-container {\n    text-align: center;\n    width: auto !important;\n    background-color: #f8f9fa;\n    padding: 35px 15px;\n    row-gap: 0;\n}\n\n.copy-right {\n    color: #6c757d;\n    font-weight: bold;\n}\n\n.author {\n    text-decoration: none;\n    color: var(--primary-theme-color);\n    font-weight: lighter;\n}\n\n.link {\n    text-decoration: none;\n    color: var(--primary-theme-color);\n    font-family: sans-serif;\n    font-weight: bold;\n}\n\n.author:hover,\n.link:hover {\n    text-decoration: underline;\n}\n\n.question {\n    margin: 30px;\n    border-radius: 15px;\n    background-color: white;\n}\n\n.question * {\n    color: black;\n    font-size: 2.8em;\n}\n\n.try-btn {\n    background: linear-gradient(90deg, rgb(195 13 255) 0%, rgb(13, 134, 255) 50%, rgb(124, 200, 244) 100%);\n    padding: 1.25rem 5rem;\n    font-size: 1.5rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    border: 0;\n    border-radius: 10rem;\n    margin-bottom: 20px;\n    color: white;\n}\n\n.try-btn:hover {\n    cursor: pointer;\n    background-color: var(--primary-theme-color-hover);\n}\n\n.portfolio * {\n    font-family: sans-serif;\n}\n\n.language {\n    margin-left: auto;\n    display: flex;\n    justify-content: center;\n}\n\n.lang-btn,\n.share-btn {\n    cursor: pointer;\n    background-color: transparent;\n    border: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.lang-btn>span {\n    margin-top: 3px;\n    font-family: \"Kodchasan-Bold\";\n}\n\n.lang-btn:hover {\n    text-decoration: underline;\n}\n\n.flag {\n    width: 20px;\n    height: 20px;\n    margin: 0 5px;\n}\n\n.concated {\n    display: flex;\n}\n\n.unconcated {\n    display: none;\n}\n\n.share-btn {\n    color: white;\n    background-color: #3b5998;\n    padding: 5px;\n    justify-content: flex-start;\n    padding-left: 10px;\n}\n\n.share-btn>span {\n    font-family: sans-serif;\n    margin: auto;\n    font-weight: bold;\n}\n\n.quick-overview-title {\n    font-size: 2.8em;\n    color: var(--primary-theme-color);\n    margin: 0;\n    font-weight: bold;\n    text-align: center;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.qo-content {\n    display: flex;\n    width: 80%;\n    flex-flow: row wrap;\n    border-radius: 5px;\n    padding-bottom: 100px;\n    margin: auto;\n}\n\n.qo-content img {\n    width: 40%;\n    border-radius: 5px;\n    margin: auto;\n}\n\n.qo-content-text {\n    width: 50%;\n    margin: 0;\n    padding: 0 20px;\n}\n\n.qo-content-title {\n    margin: 0;\n    text-align: left;\n}\n\n/* .qo-content:nth-of-type(odd){\n\tborder-left: 5px solid var(--primary-theme-color);\n}\n.qo-content:nth-of-type(even){\n\tborder-right: 5px solid var(--primary-theme-color);\n} */\n.qo-content-odd,\n.qo-content-even {\n    text-align: justify;\n    font-size: 1.2rem;\n    font-family: sans-serif\n}\n\n.qo-content-title-even {\n    margin-top: 0;\n}\n\n.qo-content-2 {\n    margin-left: auto;\n}\n\n.hash-tag a {\n    color: var(--primary-theme-color);\n    text-decoration: unset;\n    font-size: 2.5rem;\n}\n\n.hash-tag a:hover {\n    text-decoration: underline;\n}\n\n.gallery-container {\n    display: flex;\n    flex-flow: row wrap;\n    flex-direction: row;\n    width: 100%;\n\n    .gallery-item {\n        margin: 5px;\n        width: 32%;\n    }\n\n    .gallery-try-item {\n        height: fit-content;\n        align-self: flex-start;\n\n        .gallery-img {\n            height: auto;\n            width: 90%;\n        }\n    }\n\n    .lazyload-wrapper {\n        width: 100%;\n        height: 100%;\n    }\n\n    .gallery-img {\n        width: 100%;\n        height: 100%;\n        border-radius: 10px;\n        cursor: pointer;\n    }\n}\n\n.gallery-content {\n    width: 60%;\n    font-size: 1.2rem;\n    font-family: sans-serif;\n    margin-top: 0;\n}\n\n.slogan {\n    color: white;\n    margin: 0 12px;\n    background-color: var(--primary-theme-color);\n    border-radius: 20px;\n    font-size: 1.1rem;\n    width: 87%;\n    text-align: left;\n    padding: 5px 10px;\n    margin-bottom: 10px;\n    font-family: 'Kodchasan-Light';\n}\n\n.banner {\n    background-color: var(--primary-theme-color);\n    background-image: url('../assets/images/deadpool-wolverine-banner.jpg');\n    background-size: cover;\n    padding: 160px 20px 0 20px;\n    height: 70%;\n    width: fit-content;\n}\n\n.banner * {\n    color: white;\n    font-family: \"Poppins\", Sans-serif;\n    margin: 10px;\n}\n\n.banner .banner-slogan {\n    width: 50%;\n    margin: 10px 80px;\n}\n\n.banner h1 {\n    font-size: 3rem;\n    margin-bottom: 5px;\n}\n\n.banner .slogan1 {\n    font-size: 1.7rem;\n}\n\n.banner .slogan2 {\n    font-size: 1.2rem;\n}\n\n.banner .banner-btn {\n    display: flex;\n    background-color: white;\n    border-radius: 5px;\n    cursor: pointer;\n    width: 40%;\n    margin: 20px 10px;\n    border: 2px solid #fff;\n}\n\n.banner .banner-btn p {\n    background-image: linear-gradient(to bottom right, #dc6bfe, #69b1ff);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    margin: 15px auto;\n    font-weight: bold;\n    font-size: large;\n}\n\n.banner .banner-btn:hover {\n    background-color: transparent;\n}\n\n.banner .banner-btn:hover p {\n    background-image: none;\n    -webkit-text-fill-color: white;\n}\n\n.banner .banner-img {\n    width: 50%;\n    height: var(--img-frame-max-width);\n}\n\n.banner .banner-img img {\n    width: 20%;\n    border-radius: 5px;\n}\n\n.banner .banner-img img:nth-of-type(odd) {\n    align-self: self-start;\n}\n\n.banner .banner-img img:nth-of-type(even) {\n    align-self: center;\n}\n\n.gallery-try-btn,\n.fs-try-btn {\n    background: linear-gradient(90deg, rgb(195 13 255) 0%, rgb(13, 134, 255) 50%, rgb(124, 200, 244) 100%);\n    padding: 1rem 9rem;\n    font-size: 1rem;\n    font-weight: 500;\n    text-transform: uppercase;\n    border: 0;\n    border-radius: 10rem;\n    margin: auto;\n    margin-top: 12px;\n    color: white;\n}\n\n.gallery-try-btn {\n    display: none;\n}\n\n/* .keyword {\n    color: var(--primary-theme-color);\n    font-family: sans-serif;\n} */\n\n.term-content {\n    margin-top: 150px;\n    text-align: justify;\n}\n\n.term-content .keyword {\n    font-family: sans-serif;\n    font-weight: bold;\n}\n\n.term-table {\n    width: 85%;\n    margin: auto;\n}\n\n.term-table .table-head,\n.term-table .table-title {\n    color: var(--primary-theme-color);\n    margin-bottom: 0;\n    margin-top: 5px;\n}\n\n/* .term-table .table-sub-title {\n    font-style: italic;\n} */\n.title-letter,\n.li-letter {\n    width: 5%;\n}\n\n.li-letter {\n    font-size: 20px;\n}\n\n.term-table ol {\n    margin: 0;\n}\n\n.term-table li {\n    margin: 6px 0;\n}\n\n.term-table tr {\n    vertical-align: top;\n}\n\n.term-container {\n    background-color: #f1f1f1;\n    padding-bottom: 20px;\n}\n\n.back-btn {\n    margin: 20px 0;\n    padding: 15px 0;\n    background-color: var(--primary-theme-color);\n    color: white;\n    font-size: large;\n    max-width: var(--img-frame-max-width);\n}\n\n.back-btn:hover {\n    background-color: var(--primary-theme-color-hover);\n}\n\n.term-privacy {\n    width: 45%;\n}\n\n.modal-base {\n    top: 20%;\n    position: relative;\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border-radius: 10px;\n    width: 75%;\n    opacity: 0;\n    -webkit-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n    transform: scale(0.8);\n    text-align: center;\n}\n\n.modal-base .CircularProgressbar {\n    width: 10%;\n}\n\n.modal-base_after-open {\n    opacity: 1;\n    transform: scale(1);\n}\n\n.modal-base_before-close {\n    transform: scale(.2);\n    opacity: 0;\n}\n\n.overlay-base {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(66, 66, 66, .5);\n    opacity: 0;\n    transition: all 0.3s ease-out;\n    z-index: 101;\n}\n\n.overlay-base_after-open {\n    opacity: 1;\n}\n\n.overlay-base_before-close {\n    opacity: 0;\n}\n\n.text-bold {\n    font-weight: bold;\n}\n\n.close-pop-up {\n    margin: 0;\n}\n\n.social-media-btn {\n    padding: 5px;\n    margin: 10px;\n    border: none;\n    cursor: pointer;\n    text-decoration: none;\n    color: #fff;\n    width: 100%;\n}\n\n.social-media-icon {\n    width: 40px !important;\n}\n\n.social-media-icon-container {\n    display: inline-flex;\n    width: 100%;\n    justify-content: flex-start;\n}\n\n.social-media-icon-id {\n    margin: auto;\n    padding-right: 40px;\n}\n\n.transform-btn-container {\n    max-width: var(--img-frame-max-width);\n    justify-content: space-between;\n}\n\n.transform-btn-container>* {\n    max-width: 48%;\n}\n\n.share-btn-container {\n    max-width: 600px;\n    justify-content: space-between;\n    padding: 20px;\n}\n\n.share-btn-container>* {\n    max-width: 40%;\n    height: 30px;\n}\n\n.jWkLDY>span {\n    font-size: 10px !important;\n    display: none;\n}\n\n.guZdik {\n    background-image: url('../assets/images/icon-upload.png');\n    background-size: cover;\n    padding: 0 !important;\n    border: none !important;\n}\n\n.image-container {\n    .guZdik {\n        height: var(--src-img-frame-max-width) !important;\n    }\n}\n\n.drag-drop-img>svg {\n    margin-left: 10px !important;\n    display: none;\n}\n\n.trial-img-container {\n    max-width: var(--img-frame-max-width);\n    justify-content: space-between;\n}\n\n.no-img-text {\n    width: 34%;\n    /* color: #54616c; */\n    color: #fff;\n    font-weight: 600;\n    font-size: 13px;\n}\n\n.trial-text {\n    color: #54616c;\n    font-weight: 600;\n}\n\n.trial-img {\n    width: 65%;\n    justify-content: space-between;\n}\n\n.trial-img img {\n    max-width: 22%;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.trial-img img:hover {\n    opacity: 0.9;\n}\n\n.img-result {\n    position: relative;\n    top: 150px;\n}\n\n.btn-list-contanier {\n    width: 100%;\n    max-width: var(--result-img-frame-max-width);\n    background-color: white;\n    border-radius: 5px;\n    margin: auto;\n}\n\n.btn-list-contanier .btn {\n    border-radius: unset;\n    border: unset;\n    border-right: solid 0.5px var(--primary-theme-color);\n}\n\n.btn-list-contanier .btn:last-child {\n    border-right: unset !important;\n}\n\n.btn-icon {\n    padding-right: 10px;\n}\n\n.btn-label {\n    font-size: small;\n}\n\n.banner-hero {\n    width: 70%;\n    max-width: 70%;\n    margin: auto;\n}\n\n.icon-left {\n    left: 0px;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.icon-right {\n    right: 0px;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n\n.carousel-icon {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 100;\n    font-size: 30px;\n    color: white;\n    padding: 40px 10px;\n    cursor: pointer;\n    background: rgba(77, 75, 75, 0.8);\n}\n\n.carousel-content {\n    display: flex;\n    border-radius: 20px;\n    position: relative;\n    flex-direction: column;\n    height: 400px;\n    justify-content: center;\n    padding: 0 60px;\n    background-size: cover;\n}\n\n.hero-banner-title {\n    margin: 0;\n    position: relative;\n    z-index: 1;\n}\n\n.carousel-content-text {\n    width: 80%;\n    text-align: justify;\n    color: white;\n    padding: 15px;\n    /* background-color: rgba(77, 75, 75, 0.8); */\n    border-radius: 5px;\n}\n\n.carousel-content-title {\n    font-size: 40px;\n    padding: 0;\n    margin: 0;\n}\n\n.hero-img {\n    height: 460px;\n    position: absolute;\n    right: -15%;\n    bottom: 0;\n}\n\n.carousel-item {\n    position: relative;\n}\n\n.flex-start {\n    justify-content: flex-start;\n}\n\n.choose-hero-icon-container {\n    position: relative;\n    padding: 10px;\n}\n\n.choose-hero-container {\n    background-color: var(--primary-theme-color);\n    position: relative;\n    top: 16px;\n    color: white;\n    padding: 0 10px;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n\n.choose-hero-title {\n    margin-top: 10px !important;\n    margin-bottom: 26px !important;\n}\n\n.hero-logo {\n    width: 70%;\n}\n\n.try-again {\n    color: var(--primary-theme-color);\n    font-weight: bold;\n}\n\n.tool-tip {\n    background: #f5f5f5c2;\n    width: 100%;\n    padding: 5px 0;\n    border-radius: 5px;\n    border: solid 1px transparent;\n    align-items: start;\n    justify-content: flex-start;\n}\n\n.tool-tip>i {\n    padding-left: 5px;\n    top: 4px;\n    position: relative;\n}\n\n.tooltip-text {\n    padding: 0 8px;\n}\n\n.fs-container {\n    width: 90%;\n    margin: auto;\n}\n\n.fs-component {\n    background-color: white;\n    border-radius: 10px;\n    width: 100%;\n    height: 400px;\n    margin-top: 20px;\n}\n\n.fs-tranform {\n    width: 70%;\n    height: 100%;\n    border-right: 2px solid #f2f4f5;\n    margin-right: 0 !important;\n}\n\n.fs-selection {\n    width: 35%;\n    height: 100%;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n.fs-tranform,\n.fs-selection {\n    margin: 20px;\n}\n\n.fs-tranform-component {\n    width: 55%;\n    row-gap: 10px;\n    height: 325px;\n    justify-content: space-between;\n}\n\n.fs-result-img {\n    width: 45%;\n}\n\n.fs-result-img .fs-img-holder,\n.fs-result-img .fs-img-display {\n    width: var(--result-img-frame-max-width) !important;\n    height: var(--result-img-frame-max-width) !important;\n    max-width: var(--result-img-frame-max-width) !important;\n    min-width: var(--result-img-frame-max-width) !important;\n    border: 2px dashed gray;\n    border-radius: 20px;\n    margin-bottom: 10px;\n}\n\n.fs-result-img .fs-img-display img {\n    height: var(--result-img-frame-max-width) !important;\n    width: var(--result-img-frame-max-width) !important;\n\n}\n\n.fs-img-holder,\n.fs-img-display {\n    width: var(--src-img-frame-max-width);\n    height: var(--src-img-frame-max-width);\n    max-width: var(--src-img-frame-max-width) !important;\n    min-width: var(--src-img-frame-max-width) !important;\n}\n\n.fs-img-display img {\n    height: var(--src-img-frame-max-width) !important;\n    width: var(--src-img-frame-max-width) !important;\n    border-radius: 20px;\n    object-fit: contain;\n    object-position: center;\n}\n\n.fs-tranform-img-container {\n    width: 100%;\n    justify-content: space-between;\n}\n\n.fs-tranform-tool {\n    row-gap: 10px;\n}\n\n.fs-gallery-container {\n    justify-content: center;\n    overflow-y: scroll;\n    height: 90%;\n    padding: 10px 0;\n}\n\n.gallery-try-item-active {\n    border: #17f952 4px solid;\n}\n\n.main-component {\n    margin-top: 125px;\n}\n\n.hover-menu {\n    padding: 0.5rem 1rem;\n}\n\n.fs-gallery-col {\n    justify-content: flex-start;\n    width: 30%;\n    row-gap: 10px;\n}\n\n.guide-step-container {\n    display: flex;\n    width: 90%;\n    justify-content: space-between;\n    margin: auto;\n}\n\n.step-container {\n    width: 30%;\n}\n\n.step-img img {\n    width: 100%;\n    border-radius: 20px;\n    height: 100%;\n}\n\n.step-img {\n    height: 400px;\n}\n\n.step1 img {\n    height: unset;\n}\n\n.fs-title {\n    margin-top: 75px;\n    margin-bottom: 30px;\n}\n\n.step-text {\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.howtofs {\n    padding-bottom: 20px;\n}\n\n.menu-item {\n    text-decoration: none;\n    color: #000;\n}\n\n.button-hide {\n    .btn {\n        cursor: default;\n    }\n\n    color: gray;\n}\n\n.button-show {\n    color: unset;\n\n    .btn {\n        cursor: pointer;\n    }\n}\n\n.w-32 {\n    width: 32% !important;\n}\n\n.w-49 {\n    width: 49% !important;\n}\n\n.w-24 {\n    width: 24% !important;\n}\n\n.gallery-container-1 {\n    justify-content: space-between;\n\n    .gallery-img {\n        width: 100% !important;\n    }\n\n    .fs-gallery-col {\n        row-gap: 20px;\n    }\n}\n\n.target-image-container {\n    width: 100%;\n    height: 2%;\n    justify-content: flex-start;\n\n    .fs-img-holder,\n    .fs-img-display {\n        min-width: 88% !important;\n        max-width: none !important;\n        width: 88%;\n        height: 86%;\n        justify-content: flex-start;\n    }\n\n    .fs-img-display img {\n        width: 88% !important;\n        height: 120px !important;\n    }\n\n    .guZdik {\n        border: #000 dashed 2px !important;\n        background-image: url('../assets/images/upload.png');\n        border-radius: 15px;\n        flex-direction: row;\n        align-self: flex-start;\n    }\n}\n\n.hidden {\n    display: none;\n}\n\nimg.user-avatar {\n    border-radius: 50%;\n    width: 15%;\n}\n\n.user-info {\n    column-gap: 10px;\n    justify-content: flex-end;\n    max-width: 235px;\n}\n.sub-text {\n    text-align: center;\n    padding: 0 15px;\n}\n\n.navbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.menu {\n    display: none;\n}\n\n.menu a {\n    text-decoration: none;\n    padding: 10px;\n    display: block;\n    text-align: start;\n}\n\n.hamburger {\n    cursor: pointer;\n    display: block;\n}\n\n.hamburger div {\n    width: 25px;\n    height: 3px;\n    background-color: #5993b1;\n    margin: 5px 0;\n    border-radius: 10px;\n}\n\n.menu.open {\n    display: block;\n}\n\n@media (min-width: 768px) {\n    .menu {\n        display: flex;\n    }\n\n    .logout {\n        display: inline-flex !important;\n    }\n    .navbar,.hamburger {\n        display: none;\n    }\n}\n.logout {\n    display: none;\n    padding-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
